export const DEFAULT_TEST_DATA_API_CALL_LIMIT = 10;

export const TestStatusMap = {
  ABORTED: 'aborted',
  CANCELLED: 'cancelled',
  COMPLETED: 'completed',
  ERROR: 'error',
  FAILED: 'failed',
  IDLE_TIMEOUT: 'idle_timeout',
  INITIATED: 'initiated',
  LAMBDA_ERROR: 'lambda error',
  PASSED: 'passed',
  PQUEUED: 'pqueued',
  QUEUED: 'queued',
  QUEUE_TIMEOUT: 'queue_timeout',
  RUNNING: 'running',
  STOPPED: 'stopped',
  TIMEOUT: 'timeout',
  SKIPPED: 'skipped',
  UNKNOWN: 'unknown',
  IGNORED: 'ignored',
};

export const TestStatusNameMap = {
  aborted: 'Aborted',
  cancelled: 'Cancelled',
  completed: 'Completed',
  error: 'Error',
  failed: 'Failed',
  idle_timeout: 'Idle Timeout',
  initiated: 'Initiated',
  'lambda error': 'Lambda Error',
  passed: 'Passed',
  pqueued: 'Pqueued',
  queued: 'Queued',
  queue_timeout: 'Queue Timeout',
  running: 'Running',
  stopped: 'Stopped',
  timeout: 'Timeout',
  skipped: 'Skipped',
  unknown: 'Unknown',
  ignored: 'Ignored',
};

export const RerunTypeMap = {
  REPRODUCE: 'reproduce',
  REPLAY: 'replay',
};

export const TestTypes = {
  CYPRESS: 'cypress',
  HYPERTEST: 'hypertest',
  HYPERTEST_CYPRESS: 'hypertest-cypress',
  PLAYWRIGHT: 'playwright',
  SELENIUM: 'selenium',
};

export const otherStatus = [
  {
    name: 'Completed',
    value: 'completed',
  },
  {
    name: 'Skipped',
    value: 'skipped',
  },
  {
    name: 'Unknown',
    value: 'unknown',
  },
  {
    name: 'Ignored',
    value: 'ignored',
  },
  {
    name: 'Idle Timeout',
    value: 'idle_timeout',
  },
  {
    name: 'Queue Timeout',
    value: 'queue_timeout',
  },
  {
    name: 'Stopped',
    value: 'stopped',
  },
  {
    name: 'Cancelled',
    value: 'cancelled',
  },

  {
    name: 'Error',
    value: 'error',
  },
  {
    name: 'Lambda Error',
    value: 'lambda error',
  },
];

export const testStatus = [
  {
    name: 'Passed',
    value: 'passed',
  },
  {
    name: 'Running',
    value: 'running',
  },
  {
    name: 'Failed',
    value: 'failed',
  },
  {
    name: 'Queued',
    value: 'queued',
  },
  ...otherStatus,
];

export const HistoryTypeMap = {
  HISTORY: 'history',
  REPRODUCE: 'reproduce',
  REPLAY: 'replay',
};

export const MARK_STATUS_OPTIONS = [
  {
    value: 'passed',
    name: 'Passed',
  },
  {
    value: 'failed',
    name: 'Failed',
  },
];

export const DYNAMIC_COMMAND_PATTERNS = {
  click: [
    {
      pattern: /^element\/[^/]+\/click$/,
      label: 'Click on Element',
    },
  ],
  element: [
    {
      pattern: /^element\/[^/]+\/name$/,
      label: 'Get Element Tag Name',
    },
    {
      pattern: /^element\/[^/]+\/submit$/,
      label: 'Submit Form',
    },
    {
      pattern: /^element\/[^/]+\/displayed$/,
      label: 'Is Element Displayed',
    },
    {
      pattern: /^element\/[^/]+\/selected$/,
      label: 'Is Element Selected',
    },
    {
      pattern: /^element\/[^/]+\/enabled$/,
      label: 'Is Element Enabled',
    },
    {
      pattern: /^element\/[^/]+\/click$/,
      label: 'Click on Element',
    },
    {
      pattern: /^element\/[^/]+\/value$/,
      label: 'Send Keys to Element',
    },
    {
      pattern: /^element\/[^/]+\/clear$/,
      label: 'Clear Element Text',
    },
    {
      pattern: /^element\/[^/]+\/rect$/,
      label: 'Get Element Rect',
    },
    {
      pattern: /^element\/[^/]+\/shadow$/,
      label: 'Get Element Shadow Root',
    },
    {
      pattern: /^element\/[^/]+\/computedrole$/,
      label: 'Get Computed Role',
    },
    {
      pattern: /^element\/[^/]+\/computedlabel$/,
      label: 'Get Computed Label',
    },
    {
      pattern: /^element\/[^/]+\/screenshot$/,
      label: 'Take Element Screenshot',
    },
    {
      pattern: /^element\/[^/]+\/upload$/,
      label: 'Upload File to Element',
    },
    {
      pattern: /^element\/[^/]+\/download$/,
      label: 'Download File from Element',
    },
    {
      pattern: /^element\/[^/]+\/text$/,
      label: 'Get Element Text',
    },
    {
      pattern: /^element\/[^/]+\/isDisplayed$/,
      label: 'Check if Element is Displayed',
    },
    {
      pattern: /^element\/[^/]+\/isEnabled$/,
      label: 'Check if Element is Enabled',
    },
    {
      pattern: /^element\/[^/]+\/isSelected$/,
      label: 'Check if Element is Selected',
    },
    {
      pattern: /^element\/[^/]+\/drag$/,
      label: 'Drag Element',
    },
    {
      pattern: /^element\/[^/]+\/tap$/,
      label: 'Tap on Element',
    },
    {
      pattern: /^element\/[^/]+\/location$/,
      label: 'Get Element Location',
    },
    {
      pattern: /^element\/[^/]+\/size$/,
      label: 'Get Element Size',
    },
    {
      pattern: /^element\/[^/]+\/location_in_view$/,
      label: 'Get Element Location in View',
    },
    {
      pattern: /^shadow\/[^/]+\/element$/,
      label: 'Find Element From Shadow Root',
    },
    {
      pattern: /^element\/[^/]+\/attribute\/[^/]+$/,
      label: 'Get Element Attribute',
    },
    {
      pattern: /^element\/[^/]+\/css\/[^/]+$/,
      label: 'Get Element CSS Value',
    },
    {
      pattern: /^element\/[^/]+\/property\/[^/]+$/,
      label: 'Get Element Property',
    },
  ],
  elements: [
    {
      pattern: /^shadow\/[^/]+\/elements$/,
      label: 'Find Elements From Shadow Root',
    },
  ],
};

export const AssetType = {
  SCREENSHOT: 'screenshot',
  VIDEO: 'video',
};

export const DebuggerState = {
  RUNNING: 'running',
  PAUSED: 'paused',
  STOPPED: 'stopped',
};
